// Which form the login page opens on.
//
// Every unauthenticated arrival funnels through /login: App.js routes
// path="*" to /dashboard, and PrivateRoute bounces that to
// /login?next=<where they were headed>. So the URL already says who is
// knocking and we don't have to guess — or make them choose:
//
//   /login?next=/claim?d=WT-0042&t=…   QR code on a new unit         -> create
//   /login?next=/dashboard&new=1       share invite, no account yet  -> create
//   /login?next=/dashboard             PWA launch, alert/recap email
//                                      link, SMS link, typed URL     -> signin
//   /login                             just signed out               -> signin
//
// This page used to open on 'create' unconditionally, on the assumption that
// almost everyone arriving was new. That was true when a QR scan was the only
// way in. It now gets the common case wrong twice over: a returning customer
// is asked to confirm a new password, and 'create' mode sets
// autoComplete="new-password" — which tells a password manager NOT to fill
// the saved credential. So the form returning users landed on was the one
// their autofill wouldn't touch.
//
// 'new=1' is set only by the share-invite email, and only on the branch where
// shareDevice already established server-side (getUserByEmail) that the
// recipient has no account. It is a hint about which form to show first, never
// an authorization decision — both forms stay one click apart either way.

export const CREATE = 'create';
export const SIGNIN = 'signin';

/** True for the /claim route itself — not /claiming, /claimed, etc. */
export function isClaimPath(nextPath) {
  if (typeof nextPath !== 'string') return false;
  return nextPath === '/claim'
    || nextPath.startsWith('/claim?')
    || nextPath.startsWith('/claim/');
}

export function initialAuthMode({ nextPath, newHint } = {}) {
  if (isClaimPath(nextPath)) return CREATE;
  if (newHint === true) return CREATE;
  return SIGNIN;
}
